import { render } from "./CompaniesAndInternationPrograms.vue?vue&type=template&id=48db7432&scoped=true&ts=true"
import script from "./CompaniesAndInternationPrograms.vue?vue&type=script&lang=ts"
export * from "./CompaniesAndInternationPrograms.vue?vue&type=script&lang=ts"

import "./CompaniesAndInternationPrograms.vue?vue&type=style&index=0&id=48db7432&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ivan\\Desktop\\PROJECTS\\econom.landing-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48db7432"]])

export default __exports__